module.exports = __webpack_public_path__ + "img/flag-icon-uk.72d14dfb.png";